import { ThemeEvents } from '@theme/events';
class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
    this.frame = requestAnimationFrame(() => this.configure());
  }
  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
    cancelAnimationFrame(this.frame);
  }
  configure() {
    const component = this.querySelector('slider-component');
    const speed = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220;
    for (const slider of [component?.slider, component?.thumbnailSlider]) {
      if (slider) slider.options = { speed, waitForTransition: false, drag: true };
    }
  }
  updateMediaGallery = (event) => {
    const next = event.detail.data.html.querySelector('product-media-gallery slider-component');
    const current = this.querySelector('slider-component');
    if (!next || !current) return;
    const selector = '.product-media-gallery-main-slider .product-media-gallery__media';
    const before = [...current.querySelectorAll(selector)];
    const after = [...next.querySelectorAll(selector)];
    const target = next.dataset.selectedMediaId || after[0]?.dataset.mediaId;
    const ids = before.map(item => item.dataset.mediaId);
    const sameMedia = target && after.length === before.length && after.every(item => ids.includes(item.dataset.mediaId));
    if (sameMedia && current.slider) {
      this.configure();
      current.slider.go(ids.indexOf(target));
      return;
    }
    current.replaceWith(next);
    this.frame = requestAnimationFrame(() => {
      this.configure();
      const index = after.findIndex(item => item.dataset.mediaId === target);
      if (index >= 0 && next.slider) next.slider.go(index);
    });
  };
}
if (!customElements.get('product-media-gallery')) customElements.define('product-media-gallery', ProductMediaGallery);
